import React, {useState, useEffect} from 'react'
import axios from 'axios';
import globals from 'react-global-configuration';
import {
    BrowserRouter as Router,useParams,
    Link,
} from "react-router-dom";
import {Container, Label, LoginNotice, Col, Textarea, Btnpreguntar, Btncancelar,DivPreguntas,Containerp,HeaderListp,Pregunta,Titulop,Respuesta} from './styles'


const EnDirecto = ({showdiv, closeSetSettings,idevento}) => {

  const _URL_REST = globals.get('_URL_REST');
  const [listSettings, setSettings] = useState(false);
  const [listRespuestas, setRespuestas] = useState(false);
  const [messageLogin, setmessageLogin] = useState(''); 
  const [question, setQuestion] = useState(null);

  let { id } = useParams();
  const fetchSettings = async () => {
      const result = await axios(
          `${_URL_REST}/getsettings/${id}`,
      );
      setSettings(result.data[0])
  };

  useEffect(() => {
      fetchSettings();
  },[]);

  let iduser = sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`)
  const fetchrespuestas = async () => {
    const resultRespuestas = await axios(
        `${_URL_REST}/getrespuestaspreguntas/${iduser}/${idevento}`,
    );
    setRespuestas(resultRespuestas.data)
};

useEffect(() => {
    fetchrespuestas();
},[]);

setTimeout(function(){
    //console.log('check again')
    fetchrespuestas();
},10000)

  const questionChange = (val) => {
    setQuestion(val.target.value)
  }

    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const fetchData = async () => {

        let hasErros = null
        console.log('pregunta::1')
        if(question === null){
            console.log('pregunta::2')
            hasErros = true
            document.getElementById('message').classList.add('hasError');
        }else{
            console.log('pregunta::3')
            document.getElementById('message').classList.remove('hasError');
        }

        if(hasErros === null){ 
            console.log('pregunta::4')
            let user = sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_NAMEUSERRADIO`) + ' - '+ sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-EMAIL`) 
            let iduserq = sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`)
            const resultLog = await axios.post(`${_URL_REST}/savequestion`, { question, user, idevento,iduserq})
            console.log('resultado::',resultLog)
            if(resultLog.status === 200){
                if(resultLog.data === 'error'){
                    messageLoginChange('Se ha producido un error, intentelo más tardea')
                    document.getElementById("isdivs").className = ''
                    document.getElementById("divvolver").className = 'hide'
                }else{
                    messageLoginChange('Se ha enviado tu pregunta, Gracias')
                    document.getElementById("isdivs").className = 'hide'
                    document.getElementById("divvolver").className = ''
                }
            }else{
                messageLoginChange('Se ha producido un error, intentelo más tarde') 
                document.getElementById("isdivs").className = ''
                document.getElementById("divvolver").className = 'hide'
            }  
        }else{
            console.log('pregunta::5')
            messageLoginChange('Rellena todos los campos para enviar tu pregunta')
            document.getElementById("isdivs").className = ''
            document.getElementById("divvolver").className = 'hide'
        }
        fetchrespuestas()
    };

    const cancelData = async () => {
        setmessageLogin('');
        setQuestion(null);
        closeSetSettings();
        document.getElementById("isdivs").className = ''
    }

    return (
        <div>
        <Container className={showdiv ? 'hides animated': 'shows animated'}>
            <div id='isdivs'>
                
                <Label>Escribe tu pregunta:</Label>
                <Textarea defaultValue="Pregunta:" id="message" name="message" rows="10" cols="30"  onChange={ questionChange }>
                
                </Textarea>
                <Col>
                    <Btnpreguntar onClick={fetchData} >Enviar</Btnpreguntar>
                    <Btncancelar  onClick={cancelData}>Cancelar</Btncancelar>
                </Col>
            </div>
            <div id="divvolver" className="hide"><Btnpreguntar onClick={cancelData}>Cerrar</Btnpreguntar></div>  
            <LoginNotice>{messageLogin}</LoginNotice>
        </Container>
        
        { 
            listRespuestas.length > 0 &&
            (
                <Containerp>
                    <HeaderListp>Tus preguntas</HeaderListp>
                    {listRespuestas
                            .map(item => 
                                <Pregunta key={item.id}>
                                    <Titulop>
                                        <div>{item.question}</div>
                                    </Titulop>
                                    <Respuesta>
                                     
                                        <div dangerouslySetInnerHTML={{__html: item.ask}} />
                                    </Respuesta>
                                </Pregunta>
                            )}
                </Containerp>)
        }

        </div>

    )
}

export default EnDirecto